<template>
  <div class="comments-card__wrapper" :style="customStyle">
    <div class="comments-card">
      <div class="comments-card__title" v-if="showTitle">
        <span>{{ $l('form_label_comments') || 'Comments' }}</span>
        <span class="refresh__btn">
          <el-button icon="el-icon-refresh" circle @click="getData" />
        </span>
      </div>
      <div class="comments-card__content" v-if="!isEmpty">
        <div class="comments-card__content-items__wrapper">
          <div
            class="comments-card__content-items"
            v-for="item in data"
            :key="item.time"
          >
            <div class="comments-card__content-items__time">
              {{ item.time }}
            </div>
            <div
              class="comments-card__content-items__comments-items"
              v-for="comments in item.data"
              :key="comments.commentsCode"
              :class="{ owner: comments.isOwner }"
            >
              <div class="comments_person__mem">
                <div v-if="comments.isOwner" class="messaeg_time">
                  {{ comments.commentsLocalTime }}
                </div>
                <div v-if="comments.isOwner" class="messaeg_peo text-truncate">
                  {{ comments.commentsPersonName }}
                </div>

                <b-avatar
                  :src="comments.commentsPersonMemImgUrl"
                  size="medium"
                />

                <div v-if="!comments.isOwner" class="messaeg_peo text-truncate">
                  {{ comments.commentsPersonName }}
                </div>
                <div v-if="!comments.isOwner" class="messaeg_time">
                  {{ comments.commentsLocalTime }}
                </div>
              </div>
              <div
                class="comments_message__context"
                :class="{
                  'image-message': comments.commentsType == 'I',
                  'sample-messsage': comments.commentsType == 'P',
                  'voice-messsage': comments.commentsType == 'V',
                  'text-message': comments.commentsType == 'T',
                }"
                :style="
                  comments.isOwner
                    ? 'background-color: #E1F0FE'
                    : 'background-color: #C9F7F4'
                "
              >
                <span v-if="comments.commentsType == 'T'">
                  {{ comments.commentsMessage }}
                </span>
                <div
                  class="image-container"
                  v-if="comments.commentsType == 'I'"
                  :style="
                    comments.isOwner
                      ? 'background-color: #E1F0FE'
                      : 'background-color: #C9F7F4'
                  "
                >
                  <el-image
                    class="thumb_image"
                    :style="comments.isOwner ? 'text-align: right;' : ''"
                    :src="comments.thumbImageUrl"
                    fit="contain"
                    @click="previewImage(comments)"
                  >
                    <div slot="error">
                      <el-image
                        :style="comments.isOwner ? 'text-align: right;' : ''"
                        :src="comments.displayImageUrl"
                        fit="contain"
                        @click="previewImage(comments)"
                      />
                    </div>
                  </el-image>
                </div>

                <div
                  v-if="comments.commentsType == 'P'"
                  class="sample-container"
                  :style="
                    comments.isOwner
                      ? 'background-color: #E1F0FE;text-align: right;padding:2px 12px 0 0;'
                      : 'background-color: #C9F7F4;padding:2px 0 0 12px;'
                  "
                >
                  <div>{{ comments.sampleStyleNo }}</div>
                  <el-image
                    class="sample-image"
                    fit="contain"
                    :src="
                      !!comments.sampleDefaultImageUrl
                        ? $osscdn(comments.sampleDefaultImageUrl)
                        : '/image/static/img/nopic.jpg'
                    "
                  >
                    <template #error>
                      <img
                        src="/image/static/img/nopic.jpg"
                        style="width: 60px; height: 60px"
                      />
                    </template>
                  </el-image>
                </div>
                <div v-if="comments.commentsType == 'V'">
                  <CommentsAudio
                    :ref="`audio-${comments.commentsCode}`"
                    @play="audioPlay(`audio-${comments.commentsCode}`)"
                    :src="comments.fileUrl"
                    :duration="comments.voiceDurations"
                    :symbolPosition="comments.isOwner ? 'right' : 'left'"
                  />
                </div>
                <!-- <i class="el-icon-caret-right" v-if="comments.isOwner" />
                <i class="el-icon-caret-left" v-if="!comments.isOwner" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmpty" class="comments-card__content empty-data">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>

    <div v-show="false" class="image-viewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listMessageDisplayImage"
        :src="item.url"
        :key="item.code"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import CommentsAudio from '../comments-audio'
export default {
  components: { CommentsAudio },
  props: {
    selectionCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    recordType: { type: String, default: '' },
    showTitle: { type: Boolean, default: true },
    customStyle: { type: String, default: '' },
  },
  data() {
    return {
      localTimeZone: '',
      loading: false,
      data: [],
    }
  },
  computed: {
    listMessageDisplayImage() {
      return (
        this.data
          ?.map((item) => {
            const { data } = item
            if (!data?.length) return []
            return data
              .filter((item) => item.commentsType === 'I')
              .map((comments) => {
                const { commentsCode: code, displayImageUrl: url } = comments
                return { code, url }
              })
          })
          ?.reduce((r, n) => {
            r.push(...n)
            return r
          }, []) || []
      )
    },
    listMessageDisplayImageCode() {
      return this.listMessageDisplayImage.map((item) => item.code)
    },
    isEmpty() {
      return !this.data?.length
    },
  },
  watch: {
    data: {
      handler() {
        setTimeout(() => {
          if (!this.isEmpty) this.scrollToBottom()
        }, 500)
      },
      deep: true,
    },
  },
  async created() {
    await this.getData()
    setTimeout(() => {
      if (!this.isEmpty) this.scrollToBottom()
    }, 100)
  },
  methods: {
    async getData() {
      const localTimeZone = await this.loadLocalTimeZone()
      const params = {
        expoMeetingCode: this.expoMeetingCode,
        selectionCode: this.selectionCode,
        recordType: this.recordType,
        localTimeZone,
      }

      this.loading = true
      const res = await this.$api
        .expoMeetingCommentsListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.data = this._dataTransform(res.body.data)
      console.log(' this.data', this.data)
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    _dataTransform(data) {
      if (!data?.length) return []

      const _data = data.reduce((groups, item) => {
        const { commentsLocalTime } = item
        const time = dayjs(commentsLocalTime).format('YYYY/MM/DD')
        groups[time] = groups[time] || []
        groups[time].push(item)
        return groups
      }, {})

      let times = Object.keys(_data)
      times = times
        .map((time) => dayjs(time))
        .sort((a, b) => (a.isAfter(b) ? 1 : -1))
        .map((time) => time.format('YYYY/MM/DD'))
      return times.map((time) => {
        const data = _data[time]
        return {
          time: time,
          data: data
            .sort((a, b) => {
              const a_commentsLocalTime = dayjs(a.commentsLocalTime)
              const b_commentsLocalTime = dayjs(b.commentsLocalTime)
              return a_commentsLocalTime.isAfter(b_commentsLocalTime) ? 1 : -1
            })
            .map((item) => {
              const { commentsLocalTime } = item
              return {
                ...item,
                commentsLocalTime: dayjs(commentsLocalTime).format('HH:mm:ss'),
              }
            }),
        }
      })
    },
    previewImage({ commentsCode }) {
      const index = this.listMessageDisplayImageCode.findIndex(
        (code) => code === commentsCode
      )
      if (index < 0) return

      console.log('index >>', index)
      const viewer = this.$el.querySelector('.image-viewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    scrollToBottom() {
      const container = document.querySelector('.comments-card__content')
      const content = document.querySelector(
        '.comments-card__content-items__wrapper'
      )

      const scrollTop =
        content?.clientHeight || 0 - container?.clientHeight || 0

      container.scrollTop = scrollTop
    },
    audioPlay(audioKey) {
      const { $refs } = this
      const refKeys = Object.keys($refs)
      const keys = refKeys.filter((key) => audioKey !== key)
      if (!keys?.length) return
      keys.forEach((key) => {
        $refs[key][0]?.pause()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.comments-card__wrapper {
  --height: 600px;
}
.comments-card__wrapper .comments-card__title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(16, 16, 16, 1);
  line-height: 20px;
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .refresh__btn {
    padding-right: 10px;
    .el-button.is-circle {
      border-radius: 50% !important;
      padding: 6px;
    }
  }
}
.comments-card__wrapper .comments-card__content {
  line-height: 20px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(16, 16, 16, 1);
  background-color: rgba(247, 247, 247, 1);
  padding: 10px;
  height: var(--height);
  overflow: auto;
  &.empty-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  &::-webkit-scrollbar-corner {
    background: #179a16;
  }

  .comments-card__content-items {
    scroll-snap-align: end;
    .comments-card__content-items__time {
      text-align: center;
      font-size: 12px;
      line-height: 17px;
      color: rgba(165, 166, 165, 1);
      margin: 12px 0;
    }
    .comments-card__content-items__time:first-child {
      margin-top: 0;
    }
    .comments-card__content-items__comments-items {
      position: relative;
      // padding-left: 50px;
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-start;
      .comments_person__mem {
        position: absolute;
        left: 0;
        display: flex;
        justify-content: center;
      }
      .comments_message__context {
        background-color: #c9f7f4;
        border-radius: 5px;
        width: max-content;
        max-width: calc(100% - 40px - 20px);
        font-size: 12px;
        line-height: 1.6;
        position: relative;
        white-space: pre-line;
        word-wrap: break-word;
        word-break: break-all;
        margin-top: 50px;
        i[class^='el-icon'] {
          color: #c9f7f4;
          position: absolute;
          font-size: 18px;
          left: -11px;
          top: 4px;
        }
      }

      .comments_message__context.image-message {
        background-color: transparent !important;
        i[class^='el-icon'] {
          display: none;
        }
      }
      .comments_message__context.text-message {
        padding: 6px;
      }
      .comments_message__context.sample-messsage {
        background-color: #ffffff !important;
        > div {
          div:first-child {
            font-size: 14px;
            font-weight: 600;
            color: #4f4f4f;
          }
        }
        .sample-image {
          width: 155px;
          max-height: 103px;
        }
        i[class^='el-icon'] {
          color: #ffffff !important;
        }
      }
      .comments_message__context.voice-messsage {
        padding: 6px;
      }
    }
    .comments-card__content-items__comments-items.owner {
      padding-left: 0;
      // padding-right: 50px;
      justify-content: flex-end;
      .comments_person__mem {
        left: initial;
        right: 0;
      }
      .comments_message__context {
        background-color: #e1f0fe;
        i[class^='el-icon'] {
          color: #e1f0fe;
          position: absolute;
          right: -11px;
          left: initial;
        }
      }
    }
  }
  .comments-card__content-items:last-child {
    .comments-card__content-items__comments-items:last-child {
      margin-bottom: 16px;
    }
  }

  .messaeg_time {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #a5a6a5;
    margin: 0 5px 0 5px;
  }
  .messaeg_peo {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #101010;
    font-weight: 600;
    margin: 0 5px 0 5px;
    max-width: 200px;
  }
}
.image-container {
  width: 238px;
  height: 139px;
}
.sample-container {
  width: 179px;
  height: 137px;
}

.thumb_image {
  width: 217px;
  height: 122px;
  margin: 10px;
}
</style>
